Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.SurveyFilterGroupView extends Backbone.View
  template: JST['backbone/templates/monitoring/filters/surveys/survey_filter_group']
  className: 'survey-filter-groups'

  initialize: ({title, filterViews}) ->
    @title = title
    @filterViews = filterViews

  render: ->
    return @ if _.every @filterViews, (view) -> view.isEmpty()
    @$el.html @template
      title: @title
    @_renderView view for view in @filterViews
    @

  _renderView: (view) ->
    @$('.filters-container').append $(document.createElement('div')).html(view.render().el)
